import { Badge, BadgeVariants } from "~/components/Badge";
import { uniqueValues } from "~/utils/functions/uniqueValues";
import { Tooltip } from "~/components/Tooltip";
import { Emdash } from "~/components/Punctuation/Emdash";
import { cn } from "~/lib/utils";

// // // //

const ASSET_TABLE_BADGE_SIZE = "sm";
const ASSET_TABLE_BADGE_ROUNDED = "sm";
const ASSET_TABLE_BADGE_CLASS_NAME =
    "w-min whitespace-nowrap overflow-hidden max-w-full cursor-default";

// // // //

/**
 * BadgeArrayCell
 * Renders an array of strings as a series of Badges in a stable
 * @param props
 * @returns
 */
export function BadgeArrayCell(props: {
    values: string[] | null | undefined;
    justify?: "left" | "right";
}) {
    const { values, justify = "left" } = props;

    if (!Array.isArray(values)) {
        return <Emdash />;
    }

    const allValues = values.filter((each) => each.trim() !== "");
    const items = uniqueValues(allValues);

    if (items.length === 0) {
        return <Emdash />;
    }

    const wrapperClassName = cn("flex flex-col gap-1", {
        "items-end": justify === "right",
    });

    if (items.length < 3) {
        return (
            <div className={wrapperClassName}>
                {items.map((ac) => {
                    return (
                        <Badge
                            key={ac}
                            size={ASSET_TABLE_BADGE_SIZE}
                            rounded={ASSET_TABLE_BADGE_ROUNDED}
                            className={ASSET_TABLE_BADGE_CLASS_NAME}
                            label={<span className="dg-overflow">{ac}</span>}
                            variant={BadgeVariants.gray}
                        />
                    );
                })}
            </div>
        );
    }

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                <div className="px-3 flex items-center gap-2">
                    <ul className="py-1.5">
                        {items.map((ac) => (
                            <li key={ac} className="whitespace-nowrap text-xs">
                                {ac}
                            </li>
                        ))}
                    </ul>
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <div ref={setTriggerRef} className={wrapperClassName}>
                    <Badge
                        size={ASSET_TABLE_BADGE_SIZE}
                        rounded={ASSET_TABLE_BADGE_ROUNDED}
                        className={ASSET_TABLE_BADGE_CLASS_NAME}
                        label={<span className="dg-overflow">{items[0]}</span>}
                        variant={BadgeVariants.gray}
                    />
                    <Badge
                        size={ASSET_TABLE_BADGE_SIZE}
                        rounded={ASSET_TABLE_BADGE_ROUNDED}
                        className="w-min whitespace-nowrap cursor-default"
                        label={`+ ${items.length - 1} More`}
                        variant={BadgeVariants.blue}
                    />
                </div>
            )}
        </Tooltip>
    );
}
